import { PageInfo } from 'src/app/shared/models/queryparams/pageinfo.model';
import { SortInfo } from 'src/app/shared/models/queryparams/sortinfo.model';
import { UserType } from './usertype.enum';

export class UserGridRequestModel {
    Status: number = 0;
    LocationId: number | undefined;
    IncludeSubLocations: boolean = false;
    SortInfo: SortInfo = new SortInfo();
    PageInfo: PageInfo = new PageInfo();
    SearchText: string = '';
    UserType: UserType | undefined;
    RequestFrom: string = '';
    PermissionGroupId: number = 0;
}